import { LayerDefinition } from './types';

export const hrtempDefinition: LayerDefinition = {
  id: 'hrtemp',
  name: 'Temperature',
  category: 'core_met',
  categoryLabel: 'Core Meteorological',
  icon: '🌡️',
  description: '2M Surface temperature forecast with high-resolution topographic corrections.',
  sourceModels: ['hrrr', 'rrfs', 'rdps', 'gfs', 'ecmwf', 'icon13', 'RTMA (Obs)'],
  outputModels: ['Surface temperature .pmtiles per model'],
  config: {
    defaultModel: 'hrrr'
  }
};

export default hrtempDefinition;
